<template>
  <span v-if="disabled" class="disabled">
    <i :class="icon"/>{{name}}
  </span>
  <span v-else-if="active" class="active"
        @click="action">
    <i :class="icon"/>{{name}}
  </span>
  <span v-else
        :class="colorHover"
        @click="action">
    <i :class="icon"/>{{name}}
  </span>
</template>

<script>
export default {
  props: {
    name: {
      required: true,
      type: String,
      default: '',
    },
    icon: {
      required: true,
      type: String,
      default: '',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    active: {
      type: Boolean,
      default: false,
    },
    color: {
      type: String,
      default: '',
    },
  },
  name: 'ActionSimple',
  data() {
    return {
      colorHover: '',
    };
  },
  mounted() {
    if (this.color !== '') this.colorHover = this.color;
  },
  methods: {
    action() {
      this.$emit('action');
    },
  },
};
</script>

<style lang="scss" scoped>
  i { margin-right: 6px; }
  span {
    margin: 6px;
    cursor: pointer;
    padding: 5px 10px;
    border-radius: 3px;
    display: inline-block;
    color: $fb-grey-light-30;
    background-color: $fb-grey-light-94;
  }
  span:hover, .active {
    color: white;
    background-color: $fb-green;
    box-shadow: 2px 3px 5px -4px rgba(0, 0, 0, 0.2);
    -webkit-box-shadow: 2px 3px 5px -4px rgba(0, 0, 0, 0.2);
  }
  .active {
    color: white;
    background-color: $fb-grey-light-20;
  }
  .disabled {
    cursor: default;
    box-shadow: none !important;
    -webkit-box-shadow: none !important;
    color: $fb-grey-light-70 !important;
    background-color: white !important;
  }
  .red:hover { background-color: $fb-red; }
  .amber:hover { background-color: $fb-amber; }
</style>
